import type { Coding } from "@medplum/fhirtypes";

import { Systems } from "@/fhir/enums/systems";

export const TemperatureUnitToCode = { F: "[degF]", C: "Cel" } as const;
export const TemperatureUnitChoices = {
  F: "F",
  C: "C",
} as const satisfies Record<keyof typeof TemperatureUnitToCode, string>;

export const VITAL_SIGNS_FORM_ID = "vitals";

export const FAHRENHEIT_TEMPERATURE_UNIT_CODING: Coding = {
  system: Systems.UOM,
  code: TemperatureUnitToCode.F,
  display: "Fahrenheit",
};

export const CELSIUS_TEMPERATURE_UNIT_CODING: Coding = {
  system: Systems.UOM,
  code: TemperatureUnitToCode.C,
  display: "Celsius",
};
